namespace TabAurous.ECommerce {
    export interface ECommExchangeItemsForm {
        TransId: Serenity.StringEditor;
        TransItemId: Serenity.StringEditor;
        PartyId: Serenity.IntegerEditor;
        BagNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        CertificateNo: Serenity.StringEditor;
        Hallmark: Serenity.LookupEditor;
        RefNo: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductTypeId: Serenity.LookupEditor;
        ProductId: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: Serenity.LookupEditor;
        BrandId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        ProductSizeId: CommonProductSizeLookup;
        MetalId: Serenity.LookupEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        UnitRate: Serenity.DecimalEditor;
        UnitLabour: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        HSN: Serenity.LookupEditor;
        Line_No: Serenity.StringEditor;
        HasBom: Serenity.BooleanEditor;
        NetWeight: WeightEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: WeightEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: WeightEditor;
        OtherPieces: Serenity.IntegerEditor;
        OtherWeight: WeightEditor;
        MetalAmount: Serenity.DecimalEditor;
        DiamondAmount: Serenity.DecimalEditor;
        StoneAmount: Serenity.DecimalEditor;
        OtherAmount: Serenity.DecimalEditor;
        CalcOnId: Serenity.LookupEditor;
        UnitCost: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        WstPer: Serenity.DecimalEditor;
        Attribute: Serenity.StringEditor;
        CalcUnitId: Serenity.LookupEditor;
        KaratId: Serenity.LookupEditor;
        MetalColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        SieveId: StoneSieveLookup;
        GroupSieveId: StoneSieveLookup;
        Remarks: Serenity.StringEditor;
        IsDisabled: Serenity.BooleanEditor;
        ServerDate: Serenity.DateEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: WeightEditor;
        WstWt: WeightEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        SpecialRemark: Serenity.StringEditor;
        UserDescription: Serenity.StringEditor;
        AckStatus: Serenity.IntegerEditor;
        DeliveryDate: Serenity.DateEditor;
        CompanyId: Serenity.IntegerEditor;
        BagStatus: Serenity.StringEditor;
        BOMDetails: ECommExchangeBOMEditor;
        ImageName: Serenity.ImageUploadEditor;
    }

    export class ECommExchangeItemsForm extends Serenity.PrefixedContext {
        static formKey = 'ECommerce.ECommExchangeItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ECommExchangeItemsForm.init)  {
                ECommExchangeItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = CommonCategoryLookup;
                var w4 = CommonProductSizeLookup;
                var w5 = WeightEditor;
                var w6 = s.DecimalEditor;
                var w7 = s.BooleanEditor;
                var w8 = StoneSieveLookup;
                var w9 = s.DateEditor;
                var w10 = ECommExchangeBOMEditor;
                var w11 = s.ImageUploadEditor;

                Q.initFormType(ECommExchangeItemsForm, [
                    'TransId', w0,
                    'TransItemId', w0,
                    'PartyId', w1,
                    'BagNo', w0,
                    'SKU', w0,
                    'LotNo', w0,
                    'CertificateNo', w0,
                    'Hallmark', w2,
                    'RefNo', w0,
                    'ItemTypeId', w1,
                    'ProductTypeId', w2,
                    'ProductId', w0,
                    'ProductCode', w0,
                    'ProductName', w0,
                    'AttributeId', w0,
                    'CategoryId', w3,
                    'SubCategoryId', w2,
                    'BrandId', w2,
                    'SuperTypeId', w2,
                    'CollectionId', w2,
                    'ProductSizeId', w4,
                    'MetalId', w2,
                    'Pieces', w1,
                    'Weight', w5,
                    'UnitRate', w6,
                    'UnitLabour', w6,
                    'NetAmount', w6,
                    'GrossAmount', w6,
                    'HSN', w2,
                    'Line_No', w0,
                    'HasBom', w7,
                    'NetWeight', w5,
                    'DiamondPieces', w1,
                    'DiamondWeight', w5,
                    'StonePieces', w1,
                    'StoneWeight', w5,
                    'OtherPieces', w1,
                    'OtherWeight', w5,
                    'MetalAmount', w6,
                    'DiamondAmount', w6,
                    'StoneAmount', w6,
                    'OtherAmount', w6,
                    'CalcOnId', w2,
                    'UnitCost', w6,
                    'Discount', w6,
                    'WstPer', w6,
                    'Attribute', w0,
                    'CalcUnitId', w2,
                    'KaratId', w2,
                    'MetalColorId', w2,
                    'QualityId', w2,
                    'ShapeId', w2,
                    'StoneColorId', w2,
                    'StoneSizeId', w2,
                    'SieveId', w8,
                    'GroupSieveId', w8,
                    'Remarks', w0,
                    'IsDisabled', w7,
                    'ServerDate', w9,
                    'Purity', w6,
                    'PureWeight', w5,
                    'WstWt', w5,
                    'RefTransItemId', w0,
                    'RefTransId', w0,
                    'Remark', w0,
                    'SpecialRemark', w0,
                    'UserDescription', w0,
                    'AckStatus', w1,
                    'DeliveryDate', w9,
                    'CompanyId', w1,
                    'BagStatus', w0,
                    'BOMDetails', w10,
                    'ImageName', w11
                ]);
            }
        }
    }
}
